<template>
	<div class="result">
		<div class="title">查询结果</div>
		<div class="card-container" v-if="data.length === 1">
			<el-card class="card" v-if="!data[0].archived">
				<ul>
					<li>
						<span>姓名：</span>
						<span>{{ data[0].invigilator_name }}</span>
					</li>
					<li>
						<span>证书编号：</span>
						<span>{{ data[0].code }}</span>
					</li>
					<li>
						<span>发证时间：</span>
						<span>{{ data[0].certificate_at }}</span>
					</li>
					<li>
						<span>过期时间：</span>
						<span>{{ data[0].expired_at }}</span>
					</li>
					<li>
						<span>承办单位：</span>
						<span>{{ data[0].agent_name }}</span>
					</li>
				</ul>
			</el-card>
		</div>
		<el-table v-if="data.length > 1" :data="data" style="width: 96%;margin:20px auto 0" size="mini" header-row-class-name="grey" border>
			<el-table-column prop="invigilator_name" label="姓名"></el-table-column>
			<el-table-column prop="code" label="证书编号"></el-table-column>
			<el-table-column prop="certificate_at" label="发证时间"></el-table-column>
			<el-table-column prop="expired_at" label="过期时间"></el-table-column>
			<el-table-column prop="agent_name" label="承办单位"></el-table-column>
		</el-table>
	</div>
</template>
<script>
import detail from './detail';
export default {
	data() {
		return {
			dialogVisible: false,
			detailId: undefined,
			archived: false,
			query_token: null
		};
	},
	methods: {
		handleClose(done) {
			done();
		},
		showDetail(item) {
			console.log(item);
			if (item.archived) {
				this.archived = item.archived;
				this.detailId = item.archived_id;
				this.query_token = item.query_token;
			} else {
				this.archived = false;
				this.detailId = item.id;
				this.query_token = item.query_token;
			}
			this.dialogVisible = true;
		}
	},
	components: {
		detail
	},
	props: {
		data: {
			type: [Array],
			default() {
				return [];
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.result {
	border: 1px solid #eaeaea;
	margin-top: 10px;
	padding-bottom: 40px;
	.title {
		font-size: 24px;
		color: #363636;
		margin-top: 45px;
		text-align: center;
		&:after {
			content: '';
			display: block;
			width: 59px;
			height: 2px;
			background: #c9c9c9;
			margin: 0 auto;
			margin-top: 10px;
		}
	}
	.card-container {
		margin-bottom: 10px;
		.card {
			width: 80%;
			margin: 0 auto;
			padding: 20px 10px;
			li {
				margin-bottom: 15px;
				display: table;
				border-bottom: 1px solid #e7e7e7;
				padding-bottom: 15px;
				width: 100%;
				span {
					display: table-cell;
					vertical-align: baseline;

					&:first-child {
						width: 90px;
						text-align: right;
					}
					&:last-child {
						margin-left: 20px;
						text-align: left;
						word-break: break-all;
					}
				}
			}
		}
	}
}
</style>
